import { render, staticRenderFns } from "./departmentInput.vue?vue&type=template&id=3527245c&scoped=true&"
import script from "./departmentInput.vue?vue&type=script&lang=ts&"
export * from "./departmentInput.vue?vue&type=script&lang=ts&"
import style0 from "./departmentInput.vue?vue&type=style&index=0&id=3527245c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3527245c",
  null
  
)

export default component.exports